/* 
    renderDate takes an isoDateString and can convert it into another string format
    For now there are only two formats: YYYY-MM-DD or DD-MONTH-YYYY
*/

const renderDate = (isoDateString, format) => {
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const dateObject = new Date(isoDateString)
  const monthNumber = dateObject.getMonth()
  const dateNumber = dateObject.getDate()
  const year = dateObject.getFullYear()

  switch (format) {
    case 'DD Month':
      return `${dateNumber} ${MONTHS[monthNumber]}`
    case 'YYYY-MM-DD':
      return `${year}-${monthNumber}-${dateNumber}`
    case 'DD-MONTH-YYYY':
    default:
      const monthName = MONTHS[monthNumber]
      return `${dateNumber} ${monthName} ${year} `
  }
}

export { renderDate }
